// The SVG backend: the map's original renderer, kept as the fallback.
//
// It builds the same layer skeleton the WebGL backend does, as real SVG elements,
// and then does nothing per frame — the drawing code writes attributes and the
// browser paints. That is exactly the cost model the WebGL backend exists to get
// away from — cost proportional to how many elements exist rather than to how
// many changed — but it is also the reference for what the map is meant to look
// like, so it stays available.

// Installs the chained helpers (`append`, `attr`, `text`, `select`, `call`) onto
// Element. The WebGL backend provides the same surface on its own node type, so
// everything above this layer is written once.
//
// Note that this replaces the standard ParentNode.append with different
// semantics. It survives because React 17, semantic-ui and styled-components all
// use appendChild; it cannot be deleted while this backend exists.
import "../../not-d3";

const SVG_NS = "http://www.w3.org/2000/svg";

export class SvgRenderer {
  constructor(container) {
    this.kind = "svg";
    this.container = container;

    const svg = document.createElementNS(SVG_NS, "svg");
    svg.setAttribute("id", "map");
    container.appendChild(svg);

    this.root = svg;

    this.defs = svg.append("defs");

    this.parallax = svg.append("g");
    this.parallax.setAttribute("transform", "scale(0.5)");
    this.parallax.setAttribute("opacity", "0.5");

    this.lines = svg.append("g");
    this.lines.setAttribute("id", "lines");
    this.regions = this.lines.append("g");
    this.regions.setAttribute("id", "regions");
    this.lineGroup = this.lines.append("g");
    this.lineGroup.setAttribute("stroke", "#888");

    this.underlay = svg.append("g");
    this.underlay.setAttribute("id", "underlay");

    this.main = svg.append("g");
    this.main.setAttribute("id", "main");

    this.overlay = svg.append("g");
    this.overlay.setAttribute("id", "overlay");

    this.statusText = this.overlay.append("text");
    this.statusText.setAttribute("font-size", "100");
    this.statusText.setAttribute("fill", "white");
    this.statusText.setAttribute("text-anchor", "middle");
    this.statusText.setAttribute("dominant-baseline", "middle");
    this.statusText.setAttribute("font-weight", "bold");
    this.statusText.textContent = "Initialising...";
  }

  setViewport(width, height) {
    this.root.setAttribute("width", width);
    this.root.setAttribute("height", height);
    this.root.setAttribute(
      "viewBox",
      [-width / 2, -height / 2, width, height].join(" ")
    );
  }

  // The browser draws; there is nothing to do per frame.
  draw() {}

  measure(node) {
    return node.getBBox();
  }

  elementCount() {
    return this.root.getElementsByTagName("*").length;
  }

  destroy() {
    if (this.root.parentNode) this.root.parentNode.removeChild(this.root);
  }
}
